<template>
  <div class="container">
    <h5 class="title is-5">Command Log</h5>
    <div v-if="tableData.length > 0">
      <b-table
          :narrowed="true"
          :striped="true"
          :data="tableData"
      >
        <template slot-scope="props">
          <b-table-column label="#" field="num" numeric>
            {{props.row.num}}
          </b-table-column>
          <b-table-column label="Command" field="command">
            {{props.row.command}}
          </b-table-column>
          <b-table-column label="Message" field="message">
            {{props.row.message}}
          </b-table-column>
          <b-table-column label="Time" field="time" centered>
            {{props.row.time}}
          </b-table-column>
        </template>
      </b-table>
    </div>
    <div v-else>
      No commands logged.
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex';
  import BTable from "buefy/src/components/table/Table";
  import BTableColumn from "buefy/src/components/table/TableColumn";
  import {formatTime} from "../utils/utils";

  export default {
    components: {
      BTableColumn,
      BTable

    },
    name: "screen-command-log",
    data() {
      return {

      };
    },
    computed: {
      ...mapGetters('events', ['commandLog']),
      tableData() {
        let num = 0;
        return this.commandLog.map(item => {
          num++;
          return {
            ...item,
            num,
            time: formatTime(item.timestamp, 'hfts')
          };
        });
      }
    },
    mounted() {

    }
  }
</script>

<style scoped>

</style>